export default [
  {
    description: {
      en: `Dear Patients,

    Please note that if you cancel your appointment less than 24 hours in advance, a standby fee of 10,000 HUF will be charged.

    Unfortunately, we are unable to consider the reason for your absence.
    Cancellations can be made via SMS or phone.
    The standby fee must be settled at your next visit.
    Please note that we will not be able to provide further treatment until the outstanding fee is paid.

    Thank you for your understanding.`,
      hu: `Kedves Pácienseink!
      
      Felhívjuk figyelmüket, hogy amennyiben kevesebb, mint 24 órával a foglalt időpont előtt jelzik távolmaradásukat, 10.000 Ft készenléti díjat számolunk fel. 
      A távolmaradás okát sajnos nem áll módunkban figyelembe venni.
      
      Lemondásra SMS-ben és telefonon van lehetőség. 
      A KÉSZENLÉTI DÍJAT a következő személyes megjelenés alkalmával kérjük rendezni, ennek hiányában nem áll módunkban kezelést végezni.
      Megértésüket köszönjük.
      Az árlista 2026.09.16-tól visszavonásig érvényes.
      `,
      de: `Liebe Patientinnen und Patienten,

      bitte beachten Sie, dass wir bei einer Terminabsage weniger als 24 Stunden vor dem vereinbarten Zeitpunkt eine Bereitschaftsgebühr in Höhe von 10.000 HUF berechnen müssen.
      Leider können wir den Grund der Absage dabei nicht berücksichtigen.

      Eine Stornierung ist per SMS oder telefonisch möglich.

      Die Bereitschaftsgebühr ist bei Ihrem nächsten Besuch zu begleichen.
      Ohne Begleichung dieser Gebühr können wir leider keine weitere Behandlung durchführen.

      Wir danken für Ihr Verständnis.`,
    },
    headerTitle: {
      en: "Consultation",
      hu: "Konzultáció",
      de: "Konsultation",
    },
    items: [
      {
        name: {
          en: "Consultation fee",
          hu: "Konzultáció (alap)",
          de: "Beratungsgebühr",
        },
        price: "17.000,- Ft",
      },
      {
        name: {
          en: "Consultation, complex(tooth-by-tooth status, routine stomato-oncological screening, treatment plan)",
          hu: "Konzultáció, komplex csomag (szájvizsgálat, fogankénti státusz, rutin sztomato-onkológiai szűrés, kezelési terv készítése, digitalis panoráma röntgen kiértékelése)",
          de: "Beratungsgebühr, komplexes Paket (Beratung, Zahnstatus, routinemäßiges stomatoonkologisches Screening, Behandlungsplan)",
        },
        price: "22.000,- Ft",
      },
      {
        name: {
          en: "Maternal screening, counseling",
          hu: "Kismama szűrés, tanácsadás",
          de: "Mütterscreening, Beratung",
        },
        price: "17.000,- Ft",
      },
    ],
  },
  {
    headerTitle: {
      hu: "Röntgen, CT",
      en: "X-ray, CT",
      de: "Röntgen, CT",
    },
    items: [
      {
        name: {
          en: "Jaw joint CT",
          de: "Kiefer-Gelenk CT",
          hu: "Állkapocsízület CT",
        },
        price: "25.000,- Ft",
      },
      {
        name: {
          en: "Head and neck surgery CT",
          de: "Kopf-und Hals-Chirurgie CT",
          hu: "Fej - nyak sebészeti CT",
        },
        price: "25.000,- Ft",
      },
      {
        name: {
          en: "Periapical 1-3 tooth",
          de: "Periapikalem 1-3 Zahn",
          hu: "Periapicalis 1-3db fogról",
        },
        price: "5.000,- Ft",
      },
      {
        name: {
          en: "X-ray panorama digital",
          de: "Röntgen panorama digital",
          hu: "Röntgen panoráma digitális",
        },
        price: "11.000,- Ft",
      },
      {
        name: {
          en: "X-ray digital full",
          de: "Röntgen digital voll",
          hu: "Röntgen digitális tele",
        },
        price: "11.000,- Ft",
      },
      {
        name: {
          en: "Data carrier listing",
          de: "Auflistung der Datenträger",
          hu: "Adathordozó kiírás",
        },
        price: "+ 3.000,- Ft",
      },
    ],
  },
  {
    headerTitle: {
      en: "Zahnhygiene",
      de: "Dental higenia",
      hu: "Dentálhigénia",
    },
    items: [
      {
        name: {
          en: "Removal of tartar per jaw",
          de: "Zahnsteinentfernung pro Kiefer",
          hu: "Fogkő eltávolítás állcsontonként",
        },
        price: "15.000-24.000,- Ft",
      },
      {
        name: {
          en: "Plaque painting, instruction, motivation",
          de: "Plakettenmalerei, Anleitung, Motivation",
          hu: "Plakkfestés, instruálás, motiválás, polírozás",
        },
        price: "17.000,- Ft",
      },
      {
        name: {
          en: "Smile line design",
          de: "Design der Lächelnlinie",
          hu: "Mosolyvonal kialakítás",
        },
        price: "16.000,- Ft",
      },
      {
        name: {
          en: "Tooth whitening (home) rails + gel per jaw",
          de: "Zahnaufhellungsschienen (zu Hause) + Gel pro Kiefer",
          hu: "Fogfehérítés (otthoni) sín + gél állkapcsonként",
        },
        price: "60.000,- Ft/ állcsontonként",
      },
      {
        name: {
          en: "Tooth whitening (home) rails per jaw",
          de: "Zahnaufhellungsschienen (zu Hause) pro Kiefer",
          hu: "Fogfehérítés (otthoni) sín állkapcsonként",
        },
        price: "35.000,- Ft/ állcsontonként",
      },
      {
        name: {
          en: "Tooth whitening (home) gel, 2 pieces",
          de: "Zahnaufhellung (zu Hause) Gel 2 stück",
          hu: "Fogfehérítés (otthoni) gél 2 darab",
        },
        price: "25.000,- Ft/ állcsontonként",
      },
      {
        name: {
          en: "Occlusal splint (Night guard,Bruxism splint)",
          de: "Aufbissschiene (Nächtliche Aufbissschiene gegen Zähneknirschen und Zähnepressen)",
          hu: "HES (harapás emelő sín)",
        },
        price: "35.000,- Ft",
      },
      {
        name: {
          en: "Air polishing - full dentition (upper and lower jaw)",
          de: "Professionelle Air-Flow-Reinigung des vollständigen Gebisses (Ober- und Unterkiefer)",
          hu: "Air flow polírozás, teljes fogsor, alsó felső állcsont (fogkőeltávolítás után) ",
        },
        price: "20.000,- Ft",
      },

    ],
  },
  {
    headerTitle: {
      en: "Children's Dentistry",
      de: "Kinderzahnheilkunde",
      hu: "Gyermekfogászat",
    },
    items: [

      {
        name: {
          en: "Milk tooth removal",
          de: "Milchzahn-Extraktion",
          hu: "Tejfog eltávolítás",
        },
        price: "16.000, - Ft-tól",
      },
      {
        name: {
          en: "Milk tooth filling",
          de: "Milchzahnfüllung",
          hu: "Tejfog tömés",
        },
        price: "16.000 - 22.000,- Ft",
      },
      {
        name: {
          en: "Milk tooth trapping",
          de: "Trepanation eines Milchzahns",
          hu: "Tejfog trepanálás",
        },
        price: "19.000,- Ft",
      },
      {
        name: {
          en: "Temporary filling, medicinal filling",
          de: "Provisorische Füllung, medikamentöse Füllung",
          hu: "Ideiglenes tömés, gyógytömés",
        },
        price: "13.000,- Ft",
      },
      {
        name: {
          en: "Permanent filling, root canal treatment of baby teeth",
          de: "Endgültige Füllung, Wurzelbehandlung eines Milchzahns",
          hu: "Végleges tömés, tejfog gyökér kezelés",
        },
        price: "16.000,- Ft-tól",
      },
      {
        name: {
          en: "Furrow",
          de: "Fissurenversiegelung",
          hu: "Barázdazárás",
        },
        price: "16.000,-Ft-tól / foganként",
      },
      {
        name: {
          en: "Extended furrow",
          de: "Erweiterte Fissurenversiegelung",
          hu: "Kiterjesztett barázdazárás",
        },
        price: "23.000,-Ft / foganként",
      },
      {
        name: {
          en: "Milk tooth grinding",
          de: "Milchzahnabschleifen",
          hu: "Tejfog elcsiszolás / alkalmanként",
        },
        price: "16.000,-Ft",
      },
    ],
  },
  {
    categoryTitle: {
      en: "Adult treatments",
      de: "Erwachsenenbehandlungen",
      hu: "Felnőtt kezelések",
    },
    headerTitle: {
      en: "Root treatments (cofferdam isolation only)",
      de: "Wurzelbehandlungen (nur unter Kofferdam-Isolierung)",
      hu: "Gyökérkezelések (kizárólag kofferdam izolálásban)",
    },
    items: [
      {
        name: {
          en: "Front tooth (1 channel) Trepanation, length determination, medicated filling",
          de: "Frontzahn (1 Kanal): Trepanation, Längenbestimmung, medikamentöse Füllung",
          hu: "Frontfog (1 csatorna) Trepanálás, hossz meghatározás, gyógyszeres tömés",
        },
        price: "38.000,- Ft",
      },
      {
        name: {
          en: "Front teeth (1 channel) root canal treatment",
          hu: "Frontfog (1 csatorna) Gyökértömés",
          de: "Frontzahn (1 Kanal): Wurzelfüllung",
        },
        price: "38.000,- Ft",
      },
      {
        name: {
          en: "Root treatment scrub (2 channels) Trepaning, length determination, medicated filling",
          de: "Prämolar (2 Kanäle): Trepanation, Längenbestimmung, medikamentöse Füllung",
          hu: "Gyökérkezelés kisörlő (2 csatorna) Trepanálás, hossz meghatározás, gyógyszeres tömés",
        },
        price: "38.000,- Ft",
      },
      {
        name: {
          en: "Root treatment scrub (2 channels) root canal treatment",
          hu: "Gyökérkezelés kisörlő (2 csatorna) Gyökértömés",
          de: "Prämolar (2 Kanäle): Wurzelfüllung",
        },
        price: "41.000,- Ft",
      },
      {
        name: {
          en: "Root canal moral (3 channels) Trepaning, length determination, medicated filling",
          de: "Molar (3 Kanäle): Trepanation, Längenbestimmung, medikamentöse Füllung",
          hu: "Gyökérkezelés nagyörlő (3 csatorna) Trepanálás, hossz meghatározás, gyógyszeres tömés",
        },
        price: "43.000,- Ft",
      },
      {
        name: {
          en: "Root treatment molar (3 channels) root canal treatment",
          de: "Molar (3 Kanäle) Wurzelfüllung",
          hu: "Gyökérkezelés nagyörlő (3 csatorna) Gyökértömés",
        },
        price: "48.000,- Ft",
      },
      {
        name: {
          en: "Root treatment molar (4 channels) root canal treatment",
          de: "Molar (4 Kanäle): Wurzelfüllung",
          hu: "Gyökérkezelés nagyörlő (4 csatorna) Gyökértömés",
        },
        price: "48.000,- Ft-tól",
      },
      {
        name: {
          en: "Medicinal filling",
          de: "Medikamentöse Füllung",
          hu: "Gyógyszeres tömés",
        },
        price: "27.000,- Ft",
      },
    ],
  },
  {
    headerTitle: {
      en: "Root Canal Treatment removal",
      de: "Entfernung von Wurzelfüllungen",
      hu: "Gyökértömés eltávolítás",
    },
    items: [
      {
        name: {
          en: "Root Canal Treatment removal - front tooth - cleaning, medicated filling",
          de: "Frontzahn: Entfernung der Wurzelfüllung, Spülung, medikamentöse Füllung",
          hu: "Gyökértömés eltávolítás - frontfog - áttisztítás, gyógyszeres tömés",
        },
        price: "38.000,- Ft",
      },
      {
        name: {
          en: "Root Canal Treatment removal - premolar - cleaning, medicated filling",
          de: "Prämolar: Entfernung der Wurzelfüllung, Spülung, medikamentöse Füllung",
          hu: "Gyökértömés eltávolítás - kisörlő - áttisztítás, gyógyszeres tömés",
        },
        price: "43.000,- Ft",
      },
      {
        name: {
          en: "Root Canal Treatment removal - molar - cleaning, medicated filling",
          de: "Molar: Entfernung der Wurzelfüllung, Spülung, medikamentöse Füllung",
          hu: "Gyökértömés eltávolítás - nagyörlő - áttisztítás, gyógyszeres tömés",
        },
        price: "48.000,- Ft",
      },
    ],
  },
  {
    headerTitle: { en: "Fillings", de: "Füllungen", hu: "Tömések" },
    items: [
      {
        name: {
          en: "Light-curing, tooth-colored, aesthetic fillings - 1 surface",
          de: "Lichtgehärtete, zahnfarbene, ästhetische Füllungen(1 Oberfläche) ",
          hu: "Fényrekötő, fogszínű, esztétikus tömések - 1 felszín",
        },
        price: "34.000,- Ft",
      },

      {
        name: {
          en: "Light-curing, tooth-colored, aesthetic fillings - 2 surfaces",
          de: "Lichtgehärtete, zahnfarbene, ästhetische Füllungen (2 Oberflächen)",
          hu: "Fényrekötő, fogszínű, esztétikus tömések - 2 felszín",
        },
        price: "38.000,- Ft",
      },
      {
        name: {
          en: "Light-curing, tooth-colored, aesthetic fillings - 3 surfaces",
          de: "Lichtgehärtete, zahnfarbene, ästhetische Füllungen (3 Oberflächen)",
          hu: "Fényrekötő, fogszínű, esztétikus tömések - 3 felszín",
        },
        price: "41.000,- Ft",
      },
      {
        name: {
          en: "Light-curing, tooth-colored, aesthetic fillings - more surfaces",
          de: "Lichtgehärtete, zahnfarbene, ästhetische Füllungen (mehrere Oberflächen)",
          hu: "Fényrekötő, fogszínű, esztétikus tömések - több felszín",
        },
        price: "45.000,- Ft-tól",
      },
      {
        name: {
          en: "Stump construction",
          de: "Stumpfaufbau",
          hu: "Csonkfelépítés",
        },
        price: "27.000,- Ft",
      },
      {
        name: {
          en: "Medicated lining",
          de: "Medikamentöse Unterfüllung",
          hu: "Gyógyszeres alábélelés",
        },
        price: "5.000,- Ft",
      },
      {
        name: {
          en: "Cervical filling",
          de: "Cervikale Füllung",
          hu: "Nyaki tömés",
        },
        price: "22.000,- Ft",
      },
      {
        name: {
          en: "Cervical filling (per tooth)",
          de: "Cervikale Füllung (pro Zahn) ",
          hu: "Nyaki tömés 3 db-tól (foganként)",
        },
        price: "16.000,- Ft",
      },
      {
        name: {
          en: "Pre-endo structure",
          de: "Pre-Endo-Aufbau",
          hu: "Pre-endo felépítés",
        },
        price: "27.000,- Ft",
      },
    ],
  },
  {
    headerTitle: {
      en: "Oral surgery",
      de: "Oralchirurgie",
      hu: "Szájsebészet",
    },
    items: [
      {
        name: {
          en: "Oral surgery consultation",
          de: "Chirurgische Beratung",
          hu: "Szájsebészeti konzultáció",
        },
        price: "20.000,- Ft",
      },
      {
        name: {
          en: "Oral surgery milk tooth removal",
          de: "Chirurgische Milchzahn-Extraktion",
          hu: "Szájsebészeti tejfog eltávolítás",
        },
        price: "20.000,- Ft",
      },
      {
        name: {
          en: "Oral surgery tooth removal",
          de: "Chirurgische Zahnentfernung",
          hu: "Szájsebészeti fogeltávolítás",
        },
        price: "43.000,- Ft-tól",
      },
      {
        name: {
          en: "Oral surgery implant",
          de: "Chirurgische Implantation",
          hu: "Szájsebészeti implantátum",
        },
        price: "195.000-290.000,- Ft",
      },
      {
        name: {
          en: "Bone replacement",
          de: "Knochenaufbau",
          hu: "Csontpótlás",
        },
        price: "75.000,- Ft-tól",
      },
      {
        name: {
          en: "Surgical orthodontic surgery",
          de: "Chirurgische Behandlung für kieferorthopädische Zwecke",
          hu: "Sebészeti ortodonciai műtét",
        },
        price: "43.000,- Ft",
      },
      {
        name: {
          en: "Other Oral Sugery intervention",
          de: "Andere chirurgische Eingriffe: Nach individueller Kostenberechnung",
          hu: "Egyéb Szájsebészeti beavatkozás",
        },
        price: "Egyedi árajánlat alapján",
      },
      {
        name: {
          en: "Sinus closure",
          de: "Kieferhöhlenverschluss",
          hu: "Szinusz (arcüreg) zárás",
        },
        price: "27.000,- Ft",
      },
      {
        name: {
          en: "CT evaluation",
          de: "CT-Auswertung",
          hu: "CT kiértékelés",
        },
        price: "16.000,- Ft",
      },
      {
        name: {
          en: "Electrocautery treatment",
          de: "Elektrokauter-Behandlung",
          hu: "Elektrokauteres kezelés",
        },
        price: "22.000,- Ft",
      },
      {
        name: {
          en: "Closed Sinus Lift",
          de: "Geschlossene Kieferhöhlenanhebung",
          hu: "Zárt Arcüreg emelés",
        },
        price: "160.000,- Ft-tól",
      },
    ],
  },
  {
    headerTitle: {
      en: "Periodontics",
      de: "Parodontologie",
      hu: "Parodontológia",
    },
    items: [
      {
        name: {
          en: "CT evaluation",
          de: "CT-Auswertung",
          hu: "CT kiértékelés",
        },
        price: "16.000,- Ft",
      },
      {
        name: {
          en: "Initial evaluation",
          de: "Erstbewertung",
          hu: "Kezdeti kiértékelés",
        },
        price: "38.000,- Ft",
      },
      {
        name: {
          en: "Reassessment",
          de: "Nachbewertung",
          hu: "Újra kiértékelés",
        },
        price: "27.000,- Ft",
      },
      {
        name: {
          en: "Periodontal herniation per tooth",
          de: "Parodontale Kürettage (pro Zahn)",
          hu: "Parodontális küret foganként",
        },
        price: "17.000,- Ft",
      },
      {
        name: {
          en: "Periodontal horn per quadrant",
          de: "Parodontale Kürettage (pro Quadrant)",
          hu: "Parodontális küret kvadránsonként",
        },
        price: "49.000,- Ft",
      },
      {
        name: {
          en: "Periodontal surgery",
          de: "Parodontalchirurgie: Nach individueller Kostenberechnung",
          hu: "Parodontológiai műtét",
        },
        price: "Egyedi árajánlat alapján",
      },
      {
        name: {
          en: "Periodontal splinting with composite resin (aesthetic), charged per tooth",
          de: "Schienung von beweglichen Zähnen mit ästhetischem Füllungsmaterial (pro Zahn)",
          hu: "Mozgó fogak sínezése esztétikus tömőanyaggal foganként",
        },
        price: "16.000,- Ft",
      },
      {
        name: {
          en: "Stabilization of mobile teeth using a metal and fiberglass-reinforced splint 1 to 3 teeth(per tooth)",
          de: "Schienung von beweglichen Zähnen mit Metall und Glasfaser (1-3 Zähne, pro Zahn)",
          hu: "Mozgó fogak sínezése fém+üvegszálas anyaggal 1-3 fogig (foganként)",
        },
        price: "25.000,- Ft",
      },
      {
        name: {
          en: "Stabilization of mobile teeth using a metal and fiberglass-reinforced splint 4 to 6 teeth(per tooth)",
          de: "Schienung von beweglichen Zähnen mit Metall und Glasfaser (4-6 Zähne, pro Zahn)",
          hu: "Mozgó fogak sínezése fém+üvegszálas anyaggal 4-6 fogig (foganként)",
        },
        price: "18.000,- Ft",
      },
    ],
  },
  {
    headerTitle: { en: "Restorations", de: "Prothetik", hu: "Pótlások" },
    items: [
      {
        name: {
          en: "Pin Socket -  fiberglass",
          de: "Glasfaserstiftaufbau",
          hu: "Csapcsonk - Üvegszálas",
        },
        price: "43.000,- Ft",
      },
      {
        name: {
          en: "Pin Socket - molded",
          de: "Gegossener Stiftaufbau",
          hu: "Csapcsonk - Öntött",
        },
        price: "43.000,- Ft",
      },
      {
        name: {
          en: "Temporary dentures",
          de: "Provisorische Prothese",
          hu: "Ideiglenes fogsor",
        },
        price: "165.000,- Ft",
      },
      {
        name: {
          en: "Full acrylic denture per jawbone",
          de: "Vollprothese (pro Kiefer)",
          hu: "Teljes akril fogsor állcsontoként",
        },
        price: "275.000,- Ft",
      },
      {
        name: {
          en: "Metal plate denture per jawbone",
          de: "Metallgestützte Prothese (pro Kiefer)",
          hu: "Fémlemezes fogsor állcsontoként",
        },
        price: "315.000,- Ft",
      },
      {
        name: {
          en: "Underlining",
          de: "Unterfütterung",
          hu: "Alábélelés",
        },
        price: "45.000,- Ft",
      },
      {
        name: {
          en: "Denture repair",
          de: "Prothesenreparatur",
          hu: "Fogsorjavítás",
        },
        price: "32.000 - 48.000,- Ft",
      },
      {
        name: {
          en: "Crown removal (per anchor crown)",
          de: "Entfernung einer Krone (pro Krone)",
          hu: "Korona eltávolítás (horgonykoronánként)",
        },
        price: "13.000,- Ft",
      },
      {
        name: {
          en: "Crown Adhesion (per anchor crown)",
          de: "Wiedereinsatz einer Krone (pro Krone)",
          hu: "Korona visszaragasztása (horgonykoronánként)",
        },
        price: "16.000,- Ft",
      },
      {
        name: {
          en: "Temporary clinics crown",
          de: "Provisorische Krone (Praxisanfertigung)",
          hu: "Korona ideiglenes rendelői",
        },
        price: "16.000,- Ft",
      },
      {
        name: {
          en: "Technical acrylate crown / PMMA",
          de: "Technisch hergestellte Acryllat-/PMMA-Krone",
          hu: "Technikai akrilát/PMMA",
        },
        price: "26.000,- Ft",
      },
      {
        name: {
          en: "Technical metal frame with composite cover",
          de: "Technische Krone mit Metallgerüst und Kompositverblendung/Stück",
          hu: "Technikai ideiglenes korona fém erősítéssel",
        },
        price: "32.000,- Ft/db",
      },
      {
        name: {
          en: "Inlay/onlay - Gradia",
          de: "Inlay/Onlay - Gradia",
          hu: "Inlay/onlay - Gradia",
        },
        price: "102.000,- Ft",
      },
      {
        name: {
          en: "Inlay/onlay - zircon",
          de: "Inlay/onlay - Zirkon",
          hu: "Inlay/onlay - cirkon",
        },
        price: "119.000,- Ft",
      },
      {
        name: {
          en: "Removable dentures",
          de: "Herausnehmbare Prothesen: Nach individueller Kostenberechnung",
          hu: "Kivehető fogpótlások",
        },
        price: "Egyedi árajánlat alapján",
      },

      {
        name: {
          en: "Scan, consultation for design",
          de: "Scan und Beratung zur Planung",
          hu: "Scan, konzultáció tervezéshez",
        },
        price: "20.000,- Ft",
      },
      {
        name: {
          en: "Scan, for replacement work",
          de: "Scan für Prothesenarbeiten",
          hu: "Scan, pótlásmunkához",
        },
        price: "15.000,- Ft",
      },
    ],
  },
  {
    headerTitle: {
      en: "Porcelain crowns",
      de: "Porzellankronen",
      hu: "Porcelán koronák",
    },
    items: [
      {
        name: {
          en: "Zircon based ceramic crown",
          de: "Keramikkrone mit Zirkongerüst",
          hu: "Cirkon alapú kerámia korona",
        },
        price: "120.000,- Ft",
      },
      {
        name: {
          en: "Metal ceramic crown, nickel free",
          de: "Metallkeramikkrone (nickelfrei)",
          hu: "Fémkerámia korona nikkelmentes alapú",
        },
        price: "100.000,- Ft",
      },
      {
        name: {
          en: "Metal ceramic crown, titanium based",
          de: "Metallkeramikkrone (Titan)",
          hu: "Fémkerámia korona titán alapú",
        },
        price: "120.000,- Ft",
      },
      {
        name: {
          en: "Frilled shoulder crown",
          de: "Gefräste Schulterkrone",
          hu: "Frézélt vállas korona",
        },
        price: "120.000,- Ft",
      },
      {
        name: {
          en: "Crown for Implants/Implant + titan base from",
          de: "Krone auf Implantaten/ Implantat + Titanbasis ab",
          hu: "Implantátumokra készülő korona",
        },
        price: "156.000,- Ft-tól / implant + titán bázis",
      },
    ],
  },
  {
    headerTitle: {
      en: "Conscious sedation",
      de: "Sedierung",
      hu: "Éber szedáció",
    },
    items: [
      {
        name: {
          en: "Conscious sedation with nitrous oxide (First 30 minute)",
          de: "Bewusste Sedierung mit Lachgas (erste 30 Minuten)",
          hu: "Éber szedáció dinitrogén oxiddal első 30 perc",
        },
        price: "35.000,- Ft",
      },
      {
        name: {
          en: "Conscious sedation with nitrous oxide, Each additional started 30 minutes",
          de: "Bewusste Sedierung mit Lachgas (weitere angefangene 30 Minuten)",
          hu: "Éber szedáció dinitrogén oxiddal, További megkezdett 30 perc ",
        },
        price: "25.000,- Ft",
      },
    ],
  },
]